import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

// Timer visual "há X min esperando" — mostrado no card mobile e no Kanban
// quando a entrega está em aguardando_conferencia (fev/2026). Atualiza a
// cada 30s. Cor escala com o tempo pra chamar atenção do supervisor:
//   ≤5min  → violeta (calmo)
//   6–15   → âmbar  (atenção)
//   >15    → vermelho pulsante (urgente — pedido esquecido no balcão)

function formatWaitTime(diffMs) {
  const m = Math.max(0, Math.floor(diffMs / 60000));
  if (m < 1) return "há menos de 1 min esperando";
  if (m < 60) return `há ${m} min esperando`;
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h < 24) return rem ? `há ${h}h${String(rem).padStart(2, "0")} esperando` : `há ${h}h esperando`;
  const d = Math.floor(h / 24);
  return `há ${d}d esperando`;
}

function toneFor(diffMs) {
  const m = diffMs / 60000;
  if (m > 15) return "bg-red-600 text-white border-red-700 animate-pulse";
  if (m > 5) return "bg-amber-500 text-white border-amber-600";
  return "bg-violet-600 text-white border-violet-700";
}

export function WaitingTimer({ sinceIso, size = "md", testId }) {
  // Só precisamos re-render a cada 30s (o texto muda no minuto) — o intervalo
  // fica dentro do componente pra não vazar quando o card é desmontado.
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);
  if (!sinceIso) return null;
  const started = Date.parse(sinceIso);
  if (Number.isNaN(started)) return null;
  const diffMs = now - started;
  const text = formatWaitTime(diffMs);
  const tone = toneFor(diffMs);
  const cls = size === "sm"
    ? "text-[10px] px-1.5 py-0.5 gap-0.5"
    : "text-[11px] px-2 py-1 gap-1";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-extrabold uppercase tracking-wide shadow-sm ${cls} ${tone}`}
      data-testid={testId}
      data-wait-minutes={Math.floor(diffMs / 60000)}
    >
      <Clock className={size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3"} />{text}
    </span>
  );
}

// Helper para escolher o timestamp de referência mais preciso — prefere o
// campo dedicado (aguardando_conferencia_at) e cai pra hr_saida (setado no
// mesmo momento em transições) e depois created_at.
export function pickWaitSince(entrega) {
  if (!entrega) return null;
  return (
    entrega.aguardando_conferencia_at ||
    entrega.hr_saida ||
    entrega.updated_at ||
    entrega.created_at ||
    null
  );
}
